import React, { useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import { postResetPassword } from "../../services/authServices";
import { handleErrors } from "../../services/handleErrors";

import { SpinnerButtonPrimary } from "../../ui/buttons";
import { PasswordInput } from "../PasswordInput";
import { Input, SubTitle, Title, Label, LinkContainer, InputContainer } from "./styles";

const FormReset = ({ onReset, lastForgetRequest, title, action }) => {
  const [validPassword, setvalidPassword] = useState(false);
  const formik = useFormik({
    initialValues: {
      email: lastForgetRequest.email,
      code: "",
      password: "",
      confirm: "",
    },
    onSubmit: async ({ code, password }) => {
      try {
        const { message } = await postResetPassword({
          email: lastForgetRequest.email,
          code,
          password,
          verification: lastForgetRequest.verification,
        });
        toast.success(message);
        onReset();
      } catch (error) {
        handleErrors(error, toast.error, null, formik);
      }
    },
    validationSchema: Yup.object().shape({
      code: Yup.string().required("Este campo es requerido.").length(6, "El codigo de verificacion es de 6 numeros."),
      password: Yup.string()
        .required("Este campo es requerido.")
        .test("valid-password", "Password invalida", () => validPassword),
      confirm: Yup.string()
        .required("Este campo es requerido.")
        .oneOf([Yup.ref("password"), null], "La confirmacion de la contraseña no coincide"),
    }),
  });

  return (
    <>
      <div>
        <Title>{title}</Title>
        <SubTitle>Ingrese el codigo que le enviamos a su email</SubTitle>
      </div>
      <form className="pt-2 theme-form" onSubmit={formik.handleSubmit}>
        <div className="form-group mb-1">
          <Label className="col-form-label pt-0">Usuario</Label>
          <p className="font-weight-bold col-form-label ml-2">{formik.values.email}</p>
        </div>

        <InputContainer>
          <Label className="pt-0">Código de verificacion</Label>
          <Input
            className={formik.errors.code && formik.touched.code ? "form-control error-field" : "form-control"}
            type="number"
            name="code"
            maxLength="6"
            placeholder="Ingrese el codigo"
            disabled={formik.isSubmitting}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.code}
          />
          {formik.errors.code && formik.touched.code && (
            <div className="input-feedback" style={{ height: "8px" }}>
              {formik.errors.code}
            </div>
          )}
        </InputContainer>

        <InputContainer>
          <Label className="pt-0">Contraseña</Label>
          <PasswordInput
            className={formik.errors.password && formik.touched.password ? "error-field" : ""}
            style={formik.errors.password && formik.touched.password ? { border: "1px solid red", borderRadius: "5px" } : { borderRadius: "5px" }}
            name="password"
            placeholder="Ingrese su nueva contraseña"
            disabled={formik.isSubmitting}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.password}
            onValidChange={setvalidPassword}
          />
          {formik.errors.password && formik.touched.password && (
            <div className="input-feedback" style={{ height: "8px" }}>
              {formik.errors.password}
            </div>
          )}
        </InputContainer>

        <InputContainer>
          <Label className="pt-0">Repita la contraseña</Label>
          <PasswordInput
            className={formik.errors.confirm && formik.touched.confirm ? "error-field" : ""}
            style={formik.errors.password && formik.touched.password ? { border: "1px solid red", borderRadius: "5px" } : { borderRadius: "5px" }}
            name="confirm"
            placeholder="Ingrese su nueva contraseña"
            disabled={formik.isSubmitting}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.confirm}
          />
          {formik.errors.confirm && formik.touched.confirm && (
            <div className="input-feedback" style={{ height: "8px" }}>
              {formik.errors.confirm}
            </div>
          )}
        </InputContainer>

        <div className="mt-4 mb-0">
          <SpinnerButtonPrimary
            className="btn-block"
            maxHeight="40px"
            padding="20px"
            justifyContent="center"
            marginRight="0px"
            isLoading={formik.isSubmitting}
            disabled={formik.isSubmitting}
            type="submit"
          >
            {action}
          </SpinnerButtonPrimary>
        </div>
        <LinkContainer>
          <Link to="/login">Cancelar</Link>
        </LinkContainer>
      </form>
    </>
  );
};

export default FormReset;
